import { ease } from '../common/directives/svgTransition'

export const transitionTiming = {
  easing: ease.outCubic,
  duration: 500
}
